import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { Accordion, Badge, Button, ButtonGroup, Col, Container, FloatingLabel, Form, FormLabel, Image, InputGroup, Row, Spinner, Tab, Table, Tabs, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LoginInfo } from '../../App';
import { isAdmin } from '../../service/LoginService';
import ApiFetch from '../ApiFetch';
import CampaignMessage from '../CampaignMessage';
import Category from '../Category';
import Dialog from '../Dialog';
import FavoriteIcon from '../FavoriteIcon';
import Footer from '../Footer';
import Header from '../Header';
import { rankingBgColor, rankingOpacity } from "../common/RankingUtil";
import { Bar, Line } from 'react-chartjs-2';
import { Chart, registerables } from "chart.js"
import ImageViewPopup from '../ImageViewPopup';
import Thumb from '../common/Thumb';
import CommonDialog from '../common/CommonDialog';
import { Alert, Chip, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers'
import { Delete, DeleteIcon } from 'lucide-react';
import { CircleRounded as CircleIcon } from '@mui/icons-material';
import StatusLabel from '../common/StatusLabel';

Chart.register(...registerables)

const Admin = () => {
    const mimeTypes = {
        pdf: 'application/pdf',
        png: 'image/png',
        jpg: 'image/jpeg',
        gif: 'image/gif',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        csv: 'text/csv',
        txt: 'text/plain'
    };
    const downloadBase64File = async (base64Data, fileName, mimeType = 'application/octet-stream') => {
        try {
            // Base64の形式チェック
            if (!base64Data || typeof base64Data !== 'string') {
                throw new Error('Invalid base64 data');
            }

            // Base64データをデコード
            const cleanBase64 = base64Data.replace(/^data:.*;base64,/, '');

            try {
                const byteCharacters = atob(cleanBase64);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: mimeType });

                // ファイル名のサニタイズ
                const safeFileName = fileName.replace(/[^a-z0-9.]/gi, '_');

                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = safeFileName;

                document.body.appendChild(link);
                link.click();

                // クリーンアップ
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);

                return true;
            } catch (e) {
                throw new Error('Failed to decode base64 data');
            }
        } catch (error) {
            console.error('Download failed:', error);
            throw error;
        }
    };
    function favoriteSumExecute(ymd) {
        return new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/favorite/sum/" + ymd).then((r) => {
            return r.json()
        })
    }
    function getRegistrationByDay() {
        return new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/registrations").then((r) => {
            return r.json()
        })
    }
    function getRegistrationTotalByDay() {
        return new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/registrationsTotal").then((r) => {
            return r.json()
        })
    }
    function getPostsByDay() {
        return new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/posts").then((r) => {
            return r.json()
        })
    }
    function getPostsOdaiByDay() {
        return new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/odai").then((r) => {
            return r.json()
        })
    }
    function getCommentPostsByDay() {
        return new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/common/posts").then((r) => {
            return r.json()
        })
    }
    function getFavoriteCountByDay() {
        return new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/favorite/countByDay/all").then((r) => {
            return r.json()
        })
    }
    async function getRankingImage(period, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/rankingNoCache/illustration/general/" + period + "/s_all/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function createRankingRecord(ymd) {
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/rankingRecord/", { ymd: ymd }).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function tagSearch(tag, page) {
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/tag_safe/", { tag: tag, page: page }).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getOdai3Days() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/odai/3days/").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getOdaiMonthAll(ym) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/odai/monthAll/" + ym).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function updateOdaiStatus(ym,status) {
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/odai/statusMonth/" + ym,{status:status}).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function odaiRegistExecute(odaiRegistDate, registOdai) {
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/odai/info", { ymd: odaiRegistDate, odai: registOdai }).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function odaiAutoRegistExecute(odaiRegistDate) {
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/chat/odai", { ym: odaiRegistDate }).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function deleteOdai(ymd) {
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/odai/info/"+ymd).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getReportList(page, searchDiv) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/report/list/" + page + "/" + searchDiv).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function updateReportStatus(reportId, status) {
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/report", { reportId: reportId, status: status }).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getUserCheckList(page, searchDiv) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/checkList/" + page + "/" + searchDiv).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getTopList(page, searchDiv) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/operationHistory/top/" + searchDiv + "/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getCertifiedCreatorReviewList(page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/monetization/certifiedCreatorReviewList/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getProblemList(page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/problemList/" + page).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getCertifiedCreatorReviewResult(userId, result, absolute) {
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/monetization/certifiedCreatorReviewResult/" + userId, { result: result, absolute: absolute }).then((r) => r.json().then((json) => {
            return json
        }))
    }
    function certifiedCreatorReviewResultHandler(userId, result) {
        getCertifiedCreatorReviewResult(userId, result, false).then(r => {
            if (r.result) {
                dialog("", "登録しました")
            } else {
                dialog("", r.errors)
            }
        })
    }
    function certifiedCreatorReviewResultHandlerAbsolute(userId, result) {
        getCertifiedCreatorReviewResult(userId, result, true).then(r => {
            if (r.result) {
                dialog("", "登録しました")
            } else {
                dialog("", r.errors)
            }
        })
    }
    function userSearch(word) {
        return new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/search/", { word: word }).then((r) => r.json().then((json) => {
            return json
        }))
    }
    function getAgeLimitStr(ageLimit, sexualExpression) {
        let nenrei = ""
        if (ageLimit === 1) {
            nenrei = "全年齢"
        } else if (ageLimit === 2) {
            nenrei = "PG-12"
        } else if (ageLimit === 3) {
            nenrei = "R-15"
        } else if (ageLimit === 4) {
            nenrei = "R-18"
        } else if (ageLimit === 5) {
            nenrei = "R-18G"
        }
        return nenrei
    }
    function getPostsBy1Month() {
        return new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/postsBy1Month/").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function setProblemResult(groupId, result) {
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/image/problemResult/" + groupId, { result: result }).then((r) => r.json().then((json) => {
            return json
        }))
    }
    function problemResultHandler(groupId, result) {
        setProblemResult(groupId, result).then(r => {
            if (r.result) {
                dialog("", "登録しました")
                getProblemList(1).then(r => {
                    if (r.result) {
                        setProblemList([].concat(r.data))
                    }
                })
            } else {
                dialog("", r.errors)
            }
        })
    }
    async function getChargeList() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/coin/chargeList").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function chargeConfirm(chargeId, chargeConfirmDate, chargeRemarks) {
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/coin/chargeConfirm",
            { chargeId: chargeId, chargeConfirmDate: chargeConfirmDate, chargeRemarks: chargeRemarks }).then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getIdList() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/idList").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getIdImageAdmin(userId) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/idImageAdmin/" + userId).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function idResultRegist(targetUserId, result) {
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/idResultRegist",
            { targetUserId: targetUserId, result: result }).then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getRewardsApplicants() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/rewards/applicants").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function judgeRewardsApplicants() {
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/rewards/judgeApplicants").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function updateDeliveryStatus(rewardsStatusId, status, deliveryCompany, trackingNumber, deliveryDate, deliveryAmount, fileRef) {
        let fd = new FormData()
        fd.append("rewardsStatusId", rewardsStatusId)
        fd.append("status", status)
        fd.append("deliveryCompany", deliveryCompany)
        fd.append("trackingNumber", trackingNumber)
        fd.append("deliveryDate", deliveryDate)
        fd.append("deliveryAmount", deliveryAmount)
        if(fileRef) Array.from(fileRef.current.files).forEach(file => fd.append("file[]", file))
        return await new ApiFetch().formDataUpload(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/rewards/deliveryStatus", fd).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getFile(fileId) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/rewards/file/" + fileId).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getFileList(rewardsStatusId) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/rewards/fileList/" + rewardsStatusId).then((r) => r.json().then((json) => {
            return json
        }))
    }

    async function sendBulkMessage(message, url, fixed, reason, releaseDatetime) {
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/messages/bulk", { message: message, url: url, fixed: fixed, reason: reason, releaseDatetime: releaseDatetime }).then((r) => r.json().then((json) => {
            return json
        }))
    }

    const location = useLocation()
    const navigate = useNavigate()

    const { loginInfo, setLoginInfo } = useContext(LoginInfo)

    const [favoriteSumDate, setFavoriteSumDate] = useState()
    const [rankingCreateDate, setRankingCreateDate] = useState()
    const [registrationList, setRegistrationList] = useState([])
    const [registerCount, setRegisterCount] = useState("未取得")
    const [registrationTotalList, setRegistrationTotalList] = useState([])
    const [registerTotalCount, setRegisterTotalCount] = useState("未取得")
    const [postsList, setPostsList] = useState([])
    const [favoriteList, setFavoriteList] = useState([])
    const [rankingTargetDate, setRankingTargetDate] = useState("")
    const [rankingImageList, setRankingImageList] = useState([])
    const [rankingDetail, setRankingDetail] = useState(false)
    const [rankingBlur, setRankingBlur] = useState(false)
    const [tagImageList, setTagImageList] = useState([])
    const [tagDetail, setTagDetail] = useState(false)
    const [odaiList, setOdaiList] = useState([])
    const [odaiMonthAllList, setOdaiMonthAllList] = useState([])
    const [odaiRegistDate, setOdaiRegistDate] = useState(getYm())
    const odaiDate = useRef(null)
    const odaiRef = useRef(null)
    const [registOdai, setRegistOdai] = useState("")
    const [reportList, setReportList] = useState([])
    const [userCheckList, setUserCheckList] = useState([])
    const [topList, setTopList] = useState([])
    const [certifiedCreatorReviewList, setCertifiedCreatorReviewList] = useState([])
    const [statusList, setStatusList] = useState([])
    const [problemList, setProblemList] = useState([])
    const [chargeList, setChargeList] = useState([])
    const [idList, setIdList] = useState([])
    const [idImage, setIdImage] = useState([])
    const [showDeliveryInfo, setShowDeliveryInfo] = useState(false)
    const [rewardsStatusId, setRewardsStatusId] = useState("")
    const [deliveryCompany, setDeliveryCompany] = useState("")
    const [trackingNumber, setTrackingNumber] = useState("")
    const [deliveryDate, setDeliveryDate] = useState("")
    const [deliveryAmount, setDeliveryAmount] = useState(0)
    const receipt = useRef(null)
    const [deliveryErrorMessage, setDeliveryErrorMessage] = useState("")
    const [showPreviewImage, setShowPreviewImage] = useState(false)
    const [previewImageList, setPreviewImageList] = useState([])

    const [bulkMessage, setBulkMessage] = useState("");
    const [bulkMessageUrl, setBulkMessageUrl] = useState("");
    const [bulkMessageFixed, setBulkMessageFixed] = useState(false);
    const [bulkMessageReason, setBulkMessageReason] = useState("");
    const [bulkMessageReleaseDatetime, setBulkMessageReleaseDatetime] = useState("");

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        isAdmin().then(r => {
            if (!r.result) {
                navigate("/")
            }
        })
        document.querySelector("title").textContent = "サイト管理 - アワートAI"
        odaiDate.current.value = getYm() + "-01"
    }, [])

    function createGraphData(r, title) {
        const graphData = {
            labels:
                // 軸ラベル
                // 各ラベルを配列にすることで軸ラベルが改行されて表示される
                r.map(d => [d.ymd])
            ,
            datasets: [
                // 表示するデータセット
                {
                    data: r.map(d => d.count),
                    label: title
                },
            ],
        }
        return graphData
    }
    const [showImageViewPopup, setShowImageViewPopup] = useState(false)
    const [groupId, setGroupId] = useState()
    const [radioReportSearchDiv, setReportSearchDiv] = useState("3")
    const [reportSearchPage, setReportSearchPage] = useState(1)
    const [radioUserCheckListSearchDiv, setUserCheckListSearchDiv] = useState("1")
    const [userCheckListSearchPage, setUserCheckListSearchPage] = useState(1)

    const [radioTopListSearchDiv, setTopListSearchDiv] = useState("image_edit_admin")
    const [topListSearchPage, setTopListSearchPage] = useState(1)
    const [certifiedCreatorReviewListSearchPage, setCertifiedCreatorReviewListSearchPage] = useState(1)
    const [statusPage, setStatusPage] = useState(1)
    const [chargePage, setChargePage] = useState(1)
    const [chargeConfirmDate, setChargeConfirmDate] = useState("")
    const [chargeRemarks, setChargeRemarks] = useState("")
    const [showChargeConfirm, setShowChargeConfirm] = useState(false)
    const [chargeId, setChargeId] = useState("")
    const [showIdConfirm, setShowIdConfirm] = useState(false)
    const [targetUserId, setTargetUserId] = useState("")
    const [currentIdInfo, setCurrentIdInfo] = useState("")
    const [idPage, setIdPage] = useState(1)

    const [targetUserName, setTargetUserName] = useState("")
    const [userList, setUserList] = useState([])

    const [rewardsApplicants, setRewardsApplicants] = useState([])

    const reportSearchDiv = [
        { name: "未対応", value: "1" },
        { name: "対応済", value: "2" },
        { name: "全て", value: "3" },
    ]

    const checkListSearchDiv = [
        { name: "不整合あり", value: "1" },
        { name: "不整合なし", value: "2" },
        { name: "全て", value: "3" },
    ]

    const topListSearchDiv = [
        { name: "画像の編集", value: "image_edit_admin" },
        { name: "画像の削除", value: "image_delete_admin" },
        { name: "画像のモザイク再編集", value: "image_mosaic_edit_admin" },
        { name: "年齢制限の変更", value: "age_limit_change_admin" },
        { name: "年齢制限の警告", value: "age_limit_alert" },
        { name: "画風の変更", value: "style_of_painting_change_admin" },
        { name: "モザイク是正要求", value: "mosaic_alert_admin" },
        { name: "AI生成機能の利用停止(管理者)", value: "ai_generate_suspend_admin" },
        { name: "AI生成機能の利用停止(自動)", value: "ai_generate_suspend_auto" },
        { name: "アカウントのステータス変更(一時停止)", value: "user_status_change_admin_3" },
        { name: "NGワード入力", value: "generate_image_nsfw_word" },
        { name: "生成結果BAN", value: "generated_image_ban" },
    ]

    useEffect(() => {
        getReportList(reportSearchPage, radioReportSearchDiv).then(r => {
            if (r.result) {
                setReportList(r.data)
            } else {
                alert("エラー")
            }
        })
    }, [reportSearchPage])

    useEffect(() => {
        getUserCheckList(userCheckListSearchPage, radioUserCheckListSearchDiv).then(r => {
            if (r.result) {
                setUserCheckList(r.data)
            } else {
                alert("エラー")
            }
        })
    }, [userCheckListSearchPage])

    useEffect(() => {
        getTopList(topListSearchPage, radioTopListSearchDiv).then(r => {
            if (r.result) {
                setTopList(r.data)
            } else {
                alert("エラー")
            }
        })
    }, [topListSearchPage])

    useEffect(() => {
        getCertifiedCreatorReviewList(certifiedCreatorReviewListSearchPage).then(r => {
            if (r.result) {
                setCertifiedCreatorReviewList(r.data)
            } else {
                alert("エラー")
            }
        })
    }, [certifiedCreatorReviewListSearchPage])

    useEffect(() => {
        getPostsBy1Month(statusPage).then(r => {
            if (r.result) {
                setStatusList(r.data.filter(d => d.user_name !== null))
            } else {
                alert("エラー")
            }
        })
    }, [statusPage])

    useEffect(() => {
        getChargeList(chargePage).then(r => {
            if (r.result) {
                setChargeList(r.data)
            } else {
                alert("エラー")
            }
        })
    }, [chargePage])

    useEffect(() => {
        getIdList(idPage).then(r => {
            if (r.result) {
                setIdList(r.data)
            } else {
                alert("エラー")
            }
        })
    }, [idPage])

    useEffect(() => {
        if (showIdConfirm) {
            getIdImageAdmin(targetUserId).then(r => {
                if (r.result) {
                    setIdImage(r.data)
                } else {
                    alert("エラー")
                }
            })
        }
    }, [showIdConfirm])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title, message) {
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    function getLabel(status) {
        if (status == null || status == "") return "応募する"
        if (status == "PENDING") return "応募済"
        if (status == "WON") return "当選"
        if (status == "LOST") return "落選"
        return ""
    }

    function getYm() {
        // 現在の日時を取得
        const now = new Date();

        // 年を取得
        const year = now.getFullYear();

        // 月を取得 (0-11の値なので、1を足して1-12の範囲にする)
        const month = now.getMonth() + 1;

        // 月を2桁で表示する場合
        return year + "-" + month.toString().padStart(2, '0');
    }
    return (
        <div className="wrapper">
            <header className="App-header"></header>
            <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
            <Header />
            {showImageViewPopup ? <ImageViewPopup groupId={groupId} switch={setShowImageViewPopup} /> : ""}
            <Container className='mt-3 mb-3'>
                <Tabs defaultActiveKey="ranking" className="mt-3 mb-3" onSelect={(key) => {
                    if (key === "report") {
                        getReportList(reportSearchPage, radioReportSearchDiv).then(r => {
                            if (r.result) {
                                setReportList(r.data)
                            } else {
                                alert("エラー")
                            }
                        })
                    }
                    if (key === "checkList") {
                        getUserCheckList(userCheckListSearchPage, radioReportSearchDiv).then(r => {
                            if (r.result) {
                                setReportList(r.data)
                            } else {
                                alert("エラー")
                            }
                        })
                    }
                    if (key === "topList") {
                        getTopList(topListSearchPage, radioTopListSearchDiv).then(r => {
                            if (r.result) {
                                setTopList(r.data)
                            } else {
                                alert("エラー")
                            }
                        })
                    }
                    if (key === "certifiedCreatorReviewList") {
                        getCertifiedCreatorReviewList(certifiedCreatorReviewListSearchPage).then(r => {
                            if (r.result) {
                                setCertifiedCreatorReviewList(r.data)
                            } else {
                                alert("エラー")
                            }
                        })
                    }
                    if (key === "problemList") {
                        getProblemList(1).then(r => {
                            if (r.result) {
                                setProblemList(r.data)
                            } else {
                                alert("エラー")
                            }
                        })
                    }
                    if (key === "chargeList") {
                        getChargeList(1).then(r => {
                            if (r.result) {
                                setChargeList(r.data)
                            } else {
                                alert("エラー")
                            }
                        })
                    }
                    if (key === "rewardsList") {
                        getRewardsApplicants().then(r => {
                            if (r.result) {
                                setRewardsApplicants(r.data)
                            }
                        })
                    }
                    if (key === "odai") {
                        getOdaiMonthAll(getYm()).then(r => {
                            if (r.result) {
                                setOdaiMonthAllList(r.data)
                            }
                        })
                    }
                }}>
                    <Tab eventKey="ranking" title={"ランキング"}>
                        <Accordion flush style={{ border: "1px solid #CCCCCC" }} className="mb-3">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>使い方</Accordion.Header>
                                <Accordion.Body>
                                    毎日公式ではランキングの発表をしていますが、そのためのデータの集計と表示用の画像生成の補助を行う機能になります。<br />
                                    ランキングの仕様としては、前日分のいいね数を基準に集計しています。<br />
                                    また、Twitterで発表するのは全年齢、かつお題を除外しない(すべて)の内容になります。<br />
                                    「ランキング」ではそれに合わせて表示しています。<br /><br />
                                    手順(例)<br />
                                    ①お気に入り集計<br />
                                    6/25の0時になった時点で前日の6/24のお気に入り集計を行います。<br />
                                    ②6/24のランキングを表示して、表示内容が全年齢かどうか確認し、誤りがあれば管理者権限で訂正する。<br />
                                    ③ランキング入賞履歴を6/24基準で作成する。<br />
                                    入賞履歴を作成すると各ユーザーに通知が送られます。<br />
                                    ④表示したランキングをスクショしてTwitterで発表する。<br />
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <Row>
                            <p style={{ borderBottom: "3px solid #55AAFF", fontSize: "24px", fontWeight: "bold" }}>お気に入り数集計</p>
                            <p>各作品に対する基準日内でのお気に入り数を集計します</p>
                            <p></p>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={4} style={{ margin: "0 auto" }}>
                                <Button onClick={() => {
                                    setLoading(true)
                                    favoriteSumExecute("all").then(r => {
                                        if (r.result) {
                                            alert("お気に入り全期間集計完了")
                                        } else {
                                            alert("お気に入り全期間集計失敗")
                                        }
                                        setLoading(false)
                                    })
                                }} disabled={loading}>{loading ? <Spinner animation="border" size="sm" /> : ""} お気に入り数集計(全期間)</Button>
                                <FloatingLabel controlId="favorite-date" label="集計基準年月日" className='mt-3 w-100'>
                                    <Form.Control
                                        type="date"
                                        required
                                        onChange={(e) => setFavoriteSumDate(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                                <Button onClick={(e) => {
                                    setLoading(true)
                                    if (favoriteSumDate === "") {
                                        alert("日付を指定してください。")
                                        return
                                    }
                                    favoriteSumExecute(favoriteSumDate).then(r => {
                                        if (r.result) {
                                            alert("お気に入り期間集計完了:" + favoriteSumDate)
                                        } else {
                                            alert("お気に入り期間集計失敗:" + favoriteSumDate)
                                        }
                                        setLoading(false)
                                    })
                                }} disabled={loading}>{loading ? <Spinner animation="border" size="sm" /> : ""} お気に入り集計(日付指定)</Button>
                            </Col>
                        </Row>
                        <Row>
                            <p style={{ borderBottom: "3px solid #55AAFF", fontSize: "24px", fontWeight: "bold" }}>ランキング入賞履歴作成</p>
                            <p>ランキング通知とマイページのデイリーランキング入賞履歴に反映されます。</p>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={4} style={{ margin: "0 auto" }}>
                                <Button onClick={() => {
                                    setLoading(true)
                                    createRankingRecord("all").then(r => {
                                        if (r.result) {
                                            alert("ランキング入賞履歴作成完了")
                                        } else {
                                            alert("ランキング入賞履歴作成失敗")
                                        }
                                        setLoading(false)
                                    })
                                }
                                } disabled={loading}>{loading ? <Spinner animation="border" size="sm" /> : ""} 作成(全期間)</Button>
                                <FloatingLabel controlId="favorite-date" label="基準年月日" className='mt-3 w-100'>
                                    <Form.Control
                                        type="date"
                                        required
                                        onChange={(e) => setRankingCreateDate(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                                <Button onClick={(e) => {
                                    setLoading(true)
                                    if (rankingCreateDate === "") {
                                        alert("日付を指定してください。")
                                        return
                                    }
                                    createRankingRecord(rankingCreateDate).then(r => {
                                        if (r.result) {
                                            alert("ランキング入賞履歴作成完了:" + rankingCreateDate)
                                        } else {
                                            alert("ランキング入賞履歴作成失敗:" + rankingCreateDate)
                                        }
                                        setLoading(false)
                                    })
                                }} disabled={loading}>{loading ? <Spinner animation="border" size="sm" /> : ""} 作成(日付指定)</Button>
                            </Col>
                        </Row>
                        <p style={{ borderBottom: "3px solid #55AAFF", fontSize: "24px", fontWeight: "bold" }}>ランキング</p>
                        「Twitter用テンプレ」ではTwitterに公開するための文言が自動生成されます。<br />
                        1位～18位、19位～30位の2枚に分けて公開してください。<br />
                        <Accordion flush style={{ border: "1px solid #CCCCCC" }} className="mb-3">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Twitter用テンプレ</Accordion.Header>
                                <Accordion.Body>
                                    <h4>デイリーランキング</h4>
                                    👑{rankingTargetDate.replace(/-/g, "/")} デイリーランキング<br />
                                    1位～18位<br />
                                    https://ourt-ai.work/ranking/<br /><br />

                                    #AIイラスト #AIart #AI術師さんと繋がりたい<br /><br />
                                    <hr />
                                    <h4>デイリーランキング 19位～</h4>
                                    19位～30位
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={4} style={{ margin: "0 auto" }}>
                                <FloatingLabel controlId="ranking-date" label="ランキング集計基準年月日" className='mt-3 w-100'>
                                    <Form.Control
                                        type="date"
                                        required
                                        onChange={(e) => setRankingTargetDate(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                                <Button onClick={(e) => {
                                    setLoading(true)
                                    if (favoriteSumDate === "") {
                                        alert("日付を指定してください。")
                                        return
                                    }
                                    getRankingImage(rankingTargetDate, 1).then(r => {
                                        if (r.result) {
                                            setRankingImageList(r.data)
                                        }
                                        setLoading(false)
                                    })
                                }} disabled={loading}>{loading ? <Spinner animation="border" size="sm" /> : ""} ランキング集計(日付指定)</Button>
                                <Button style={{ marginLeft: "10px" }} onClick={() => setRankingImageList([])}>リセット</Button>
                            </Col>
                        </Row>
                        <Container className='d-flex flex-row justify-content-start flex-wrap w-100'>
                            <Container>
                                <InputGroup className="mb-3" style={{ width: "200px" }}>
                                    <InputGroup.Checkbox style={{ cursor: "pointer" }} id="ranking-detaiil" onChange={(e) => {
                                        setRankingDetail(e.currentTarget.checked)
                                    }} checked={rankingDetail} />
                                    <Form.Control type="text" defaultValue="詳細表示" readOnly />
                                </InputGroup>
                                <InputGroup className="mb-3" style={{ width: "200px" }}>
                                    <InputGroup.Checkbox style={{ cursor: "pointer" }} id="ranking-blur" onChange={(e) => {
                                        setRankingBlur(e.currentTarget.checked)
                                    }} checked={rankingBlur} />
                                    <Form.Control type="text" defaultValue="ぼかし" readOnly />
                                </InputGroup>
                            </Container>
                            <Container>
                                <span className='App-logo' style={{ fontSize: "36px" }}>ourt AI</span>
                                <p style={{ backgroundColor: "orange", fontSize: "36px", fontWeight: "bold", color: "#FFFFFF", paddingLeft: "5px" }}>Daily Ranking {rankingTargetDate.replaceAll("-", "/")}</p>
                            </Container>
                            {rankingImageList.map((data, i) => {
                                return <Container style={{ position: "relative", width: "200px" }} className="mb-3 p-0" key={i}>
                                    <Container style={{ position: "relative", width: "200px", height: "200px" }} className="p-0">
                                        <p style={{ position: "absolute", top: "10px", left: "10px", zIndex: 2, backgroundColor: "#FFFFFF", display: rankingDetail ? "block" : "none" }}>
                                            <Icon.Heart /> {data.favorite_count}<br />
                                            <Icon.Eye /> {data.pv_count}<br />
                                            {data.booking_datetime === "0000-00-00 00:00:00" ? data.create_datetime : data.booking_datetime}<br />
                                        </p>
                                        <Badge bg="secondary" style={{ position: "absolute", zIndex: "1", bottom: "20px", left: "20px", display: data.img_count > 1 ? "block" : "none" }}>
                                            <Icon.CollectionFill /> {data.img_count}
                                        </Badge>
                                        <div className='text-center' style={{ position: "absolute", borderRadius: "20px", backgroundColor: rankingBgColor(data.rank), opacity: rankingOpacity(data.rank), width: "40px", height: "40px", zIndex: "1", top: "10px", left: "10px", fontWeight: "bold", fontSize: "24px" }} />
                                        <div className='text-center' style={{ position: "absolute", borderRadius: "20px", color: "#FFFFFF", width: "40px", height: "40px", zIndex: "1", top: "10px", left: "10px", fontWeight: "bold", fontSize: "24px" }}>
                                            {data.rank}
                                        </div>
                                        <Image data-no={i}
                                            onClick={() => {
                                                setShowImageViewPopup(true)
                                                setGroupId(data.group_id)
                                            }}
                                            loading="lazy" src={ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + '/post/t/' + (data.group_id) + "_in" + ApiFetch.API_THUMB_EXT}
                                            style={{ cursor: "pointer", filter: rankingBlur && data.sexual_expression === 1 ? "blur(10px)" : "none", objectFit: "cover", position: "absolute", width: "100%", height: "100%", borderRadius: "10px" }} className="p-0" />
                                    </Container>
                                    <Container style={{ fontWeight: "bold", fontSize: "15px", whiteSpace: "nowrap", overflow: "hidden" }}><Link to={"/image/" + (data.group_id)} style={{ color: "#555555", textDecoration: "none" }}>{data.title}</Link></Container>
                                    <Container style={{ whiteSpace: "nowrap", overflow: "hidden" }}><Link to={"/user/" + (data.user_id)} style={{ color: "#555555", textDecoration: "none" }}><Image loading="lazy" src={ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + '/profile/' + (data.user_id) + '_s.jpg'} style={{ borderRadius: "12px", display: data.user_id ? "inline" : "none" }} width="24px" height="24px" /> {data.user_name}</Link></Container>
                                </Container>
                            })}
                        </Container>
                    </Tab>
                    <Tab eventKey="odai" title="お題">
                        <Container>
                            <Accordion flush style={{ border: "1px solid #CCCCCC" }} className="mb-3">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>お題を登録</Accordion.Header>
                                    <Accordion.Body>
                                        <FloatingLabel controlId="odai-date" label="基準年月日" className='mt-3 w-100'>
                                            <Form.Control
                                                ref={odaiDate}
                                                type="date"
                                                required
                                                onChange={(e) => {
                                                    setOdaiRegistDate(e.currentTarget.value)
                                                    getOdaiMonthAll(e.currentTarget.value.substring(0, 7)).then(r => {
                                                        if (r.result) {
                                                            setOdaiMonthAllList(r.data)
                                                        }
                                                    })
                                                }}
                                            />
                                        </FloatingLabel>
                                        <FloatingLabel controlId="odai" label="お題" className='mt-3 mb-3 w-100'>
                                            <Form.Control
                                                ref={odaiRef}
                                                type="text"
                                                required
                                                onChange={(e) => setRegistOdai(e.currentTarget.value)}
                                            />
                                        </FloatingLabel>
                                        <Button className='m-1' onClick={(e) => {
                                            if (odaiRegistDate === "") {
                                                alert("日付を指定してください。")
                                                return
                                            }
                                            if (registOdai === "") {
                                                alert("お題を指定してください。")
                                                return
                                            }
                                            odaiRegistExecute(odaiRegistDate, registOdai).then(r => {
                                                if (r.result) {
                                                    getOdaiMonthAll(odaiRegistDate.substring(0, 7)).then(r => {
                                                        if(r.result){
                                                            setOdaiMonthAllList(r.data)
                                                        }
                                                    })
                                                } else {
                                                    alert("お題登録失敗:" + odaiRegistDate)
                                                }
                                            })
                                        }} disabled={loading}>お題登録(日付指定)</Button>

                                        <Button className='m-1' onClick={(e) => {
                                            if (odaiRegistDate === "") {
                                                alert("日付を指定してください。")
                                                return
                                            }
                                            setLoading(true)
                                            odaiAutoRegistExecute(odaiRegistDate.substring(0, 7)).then(r => {
                                                if (r.result) {
                                                    //alert("お題登録完了:" + r.data.not_regist_list.join(","))
                                                    getOdaiMonthAll(odaiRegistDate.substring(0, 7)).then(r => {
                                                        if(r.result){
                                                            setOdaiMonthAllList(r.data)
                                                        }
                                                    })
                                                } else {
                                                    alert(r.errors)
                                                }
                                                setLoading(false)
                                            })
                                        }} disabled={loading}>{loading ? <Spinner animation="border" size="sm" /> : ""} お題登録(自動)</Button>

                                        {[0, 1].map(d => {
                                            return <Button key={d} className='m-1' onClick={(e) => {
                                                if (odaiRegistDate === "") {
                                                    alert("日付を指定してください。")
                                                    return
                                                }
                                                setLoading(true)
                                                updateOdaiStatus(odaiRegistDate.substring(0,7),d).then(r => {
                                                    if (r.result) {
                                                        getOdaiMonthAll(odaiRegistDate.substring(0, 7)).then(r => {
                                                            if(r.result){
                                                                setOdaiMonthAllList(r.data)
                                                            }
                                                        })
                                                    } else {
                                                        alert(r.errors)
                                                    }
                                                    setLoading(false)
                                                })
                                            }} disabled={loading}>{loading ? <Spinner animation="border" size="sm" /> : ""} {d === 0 ? "準備中に更新" : "公開に更新"}</Button>
                                        })}
                                        <br />
                                        {odaiMonthAllList.length > 0 ? odaiMonthAllList.filter(d => d.status === 0).length > 0 ? <StatusLabel status="draft" /> : <StatusLabel status="published" /> : ""}
                                        <br />
                                        {odaiMonthAllList.length > 0 ? odaiMonthAllList.map(d => <Chip color={d.odai.length > 0 ? "default" : "error"} className='m-1' label={<>
                                            {d.ymd.substring(8,10) + ":"} {d.odai.length > 0 ? <>{d.odai} <CircleIcon fontSize="small" color={d.status === 0 ? 'action' : 'success'} /></> : "未登録"}
                                            </>} deleteIcon={<Icon.XCircle />} onDelete={() => {
                                            deleteOdai(d.ymd).then(r => {
                                                if (r.result) {
                                                    getOdaiMonthAll(odaiRegistDate.substring(0, 7)).then(r => {
                                                        if(r.result){
                                                            setOdaiMonthAllList(r.data)
                                                        }
                                                    })
                                                } else {
                                                    alert("削除失敗" + odaiRegistDate)
                                                }
                                            })
                                        }}
                                        onClick={() => {
                                            odaiDate.current.value = d.ymd
                                            setOdaiRegistDate(d.ymd)

                                            odaiRef.current.value = d.odai
                                        }}
                                        disabled={loading} />) : ""}
                                        {odaiMonthAllList.length > 0 && odaiMonthAllList.filter(d => d.odai.length === 0).length > 0 ? <Alert className='mt-3' severity='warning' color='warning'>未登録の日があります。</Alert> : ""}
                                        {odaiMonthAllList.length > 0 && odaiMonthAllList.filter(d => d.status === 0).length > 0 ? <Alert className='mt-3' severity='warning' color='warning'>準備中の日があります。</Alert> : ""}
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header
                                        onClick={() => {
                                            getOdai3Days().then(r => {
                                                if (r.result) {
                                                    setOdaiList(r.data)
                                                }
                                            })
                                        }}
                                    >Twitter用テンプレ</Accordion.Header>
                                    <Accordion.Body>
                                        <h4>昨日のお題</h4>
                                        AIイラスト生成&投稿サイト「アワートAI」<br />
                                        単語を選んでかんたん生成。<br />
                                        あなたもAIイラストを始めてみませんか？<br />
                                        https://ourt-ai.work<br /><br />

                                        ■昨日のお題は「{odaiList.length > 0 && odaiList[0].odai}」でした。<br /><br />

                                        https://ourt-ai.work/tag/{odaiList.length > 0 && encodeURI(odaiList[0].odai)}/1<br />

                                        #AIイラスト #アワートAI #AI術師さんと繋がりたい #生成AI
                                        <hr />
                                        <h4>今日のお題</h4>
                                        AIイラスト生成&投稿サイト「アワートAI」<br />
                                        AI生成機能はスマホからでも利用できます！<br />
                                        あなたもAIイラストを始めてみませんか？<br />
                                        https://ourt-ai.work<br /><br />

                                        ■今日のお題は「{odaiList.length > 0 && odaiList[1].odai}」です！<br />
                                        よろしくお願いします！<br /><br />

                                        https://ourt-ai.work/tag/{odaiList.length > 0 && encodeURI(odaiList[1].odai)}/1<br /><br />

                                        #AIイラスト #アワートAI #AI術師さんと繋がりたい #生成AI
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            <Container className='d-flex flex-row justify-content-start flex-wrap w-100'>
                                <Container className='mb-3'>
                                    <InputGroup className="mb-3" style={{ width: "200px" }}>
                                        <InputGroup.Checkbox style={{ cursor: "pointer" }} id="tag-detaiil" onChange={(e) => {
                                            setTagDetail(e.currentTarget.checked)
                                        }} checked={tagDetail} />
                                        <Form.Control type="text" defaultValue="詳細表示" readOnly />
                                    </InputGroup>
                                    <InputGroup>
                                        <InputGroup.Text><Icon.Search /></InputGroup.Text>
                                        <Form.Control
                                            id="tag"
                                            placeholder='タグ'
                                            aria-label="tag"
                                            aria-describedby="basic-addon1"
                                            onKeyDown={(e) => {
                                                let tag = document.getElementById("tag").value
                                                if (e.key === "Enter" && tag.trim().length > 0) {
                                                    tagSearch(tag, 1).then(r => {
                                                        if (r.result) {
                                                            setTagImageList(r.data)
                                                        } else {
                                                            alert(r.errors)
                                                        }
                                                    })
                                                }

                                            }}
                                        />
                                        <Button onClick={() => {
                                            let tag = document.getElementById("tag").value
                                            if (tag.trim().length > 0) {
                                                tagSearch(tag, 1).then(r => {
                                                    if (r.result) {
                                                        setTagImageList(r.data)
                                                    } else {
                                                        alert(r.errors)
                                                    }
                                                })
                                            }
                                        }}>取得</Button>
                                    </InputGroup>
                                </Container>
                                {tagImageList.map((data, i) => {
                                    return <Container style={{ position: "relative", width: "180px" }} className="m-0 p-0" key={i}>
                                        <Container style={{ position: "relative", width: "180px", height: "180px", padding: 0 }}>
                                            <p style={{ position: "absolute", top: "10px", left: "10px", zIndex: 2, backgroundColor: "#FFFFFF", display: tagDetail ? "block" : "none" }}>
                                                <Icon.Heart /> {data.favorite_count}<br />
                                                <Icon.Eye /> {data.pv_count}<br />
                                                {data.booking_datetime === "0000-00-00 00:00:00" ? data.create_datetime : data.booking_datetime}<br />
                                            </p>
                                            <Image
                                                onClick={() => {
                                                    setShowImageViewPopup(true)
                                                    setGroupId(data.group_id)
                                                }}
                                                data-no={i} loading="lazy" src={ApiFetch.API_PROTOCOL + '//' + ApiFetch.IMG_HOST + '/post/t/' + (data.id) + ApiFetch.API_THUMB_EXT}
                                                style={{ cursor: "pointer", objectFit: "cover", position: "absolute", width: "100%", height: "100%" }} className="p-0" />
                                        </Container>
                                    </Container>
                                })}
                            </Container>
                        </Container>
                    </Tab>
                    <Tab eventKey="analyze" title={"分析"}>
                        <Container fluid className="px-2">
                            <Row className="mb-3">
                                <Col>
                                    <div style={{ 
                                        padding: window.innerWidth < 768 ? "8px" : "12px", 
                                        backgroundColor: "#f8f9fa", 
                                        borderRadius: "8px",
                                        border: "1px solid #dee2e6"
                                    }}>
                                        <h5 className="mb-2" style={{ 
                                            color: "#495057",
                                            fontSize: window.innerWidth < 768 ? "16px" : "20px"
                                        }}>
                                            <Icon.BarChart className="me-2" />
                                            サイト分析ダッシュボード
                                        </h5>
                                        <p className="mb-0 text-muted" style={{
                                            fontSize: window.innerWidth < 768 ? "13px" : "14px"
                                        }}>
                                            各種統計データを確認できます。データを取得してグラフで可視化します。
                                        </p>
                                    </div>
                                </Col>
                            </Row>

                            {/* 登録者数関連 */}
                            <Row className="g-3 mb-4">
                                <Col lg={6}>
                                    <div style={{ 
                                        padding: "20px", 
                                        backgroundColor: "#ffffff", 
                                        borderRadius: "8px",
                                        border: "1px solid #dee2e6",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
                                    }}>
                                        <h6 style={{ 
                                            borderBottom: "2px solid #55AAFF", 
                                            fontSize: "18px", 
                                            fontWeight: "bold",
                                            paddingBottom: "8px",
                                            marginBottom: "16px"
                                        }}>
                                            日別登録者数
                                        </h6>
                                        <div className="mb-3">
                                            <Button 
                                                variant="primary"
                                                size={window.innerWidth < 768 ? "sm" : ""}
                                                onClick={() => getRegistrationByDay().then(r => {
                                                    if (r.result) {
                                                        setRegistrationList(<Bar data={createGraphData(r.data.list.reverse(), "日別登録者数")} />)
                                                        setRegisterCount(r.data.total)
                                                    } else {
                                                        alert("取得失敗")
                                                    }
                                                })}
                                            >
                                                <Icon.Download className="me-1" />
                                                データ取得
                                            </Button>
                                            <span className="ms-3 text-muted">
                                                総登録者数：<strong>{registerCount}</strong>
                                            </span>
                                        </div>
                                        <div style={{ height: "300px", overflow: "hidden" }}>
                                            {registrationList}
                                        </div>
                                    </div>
                                </Col>
                                
                                <Col lg={6}>
                                    <div style={{ 
                                        padding: "20px", 
                                        backgroundColor: "#ffffff", 
                                        borderRadius: "8px",
                                        border: "1px solid #dee2e6",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
                                    }}>
                                        <h6 style={{ 
                                            borderBottom: "2px solid #55AAFF", 
                                            fontSize: "18px", 
                                            fontWeight: "bold",
                                            paddingBottom: "8px",
                                            marginBottom: "16px"
                                        }}>
                                            登録者数推移
                                        </h6>
                                        <div className="mb-3">
                                            <Button 
                                                variant="primary"
                                                size={window.innerWidth < 768 ? "sm" : ""}
                                                onClick={() => getRegistrationTotalByDay().then(r => {
                                                    if (r.result) {
                                                        setRegistrationTotalList(<Bar data={createGraphData(r.data.list, "登録者数推移")} />)
                                                        setRegisterTotalCount(r.data.total)
                                                    } else {
                                                        alert("取得失敗")
                                                    }
                                                })}
                                            >
                                                <Icon.Download className="me-1" />
                                                データ取得
                                            </Button>
                                            <span className="ms-3 text-muted">
                                                総登録者数：<strong>{registerTotalCount}</strong>
                                            </span>
                                        </div>
                                        <div style={{ height: "300px", overflow: "hidden" }}>
                                            {registrationTotalList}
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            {/* 投稿数関連 */}
                            <Row className="g-3 mb-4">
                                <Col lg={12}>
                                    <div style={{ 
                                        padding: "20px", 
                                        backgroundColor: "#ffffff", 
                                        borderRadius: "8px",
                                        border: "1px solid #dee2e6",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
                                    }}>
                                        <h6 style={{ 
                                            borderBottom: "2px solid #55AAFF", 
                                            fontSize: "18px", 
                                            fontWeight: "bold",
                                            paddingBottom: "8px",
                                            marginBottom: "16px"
                                        }}>
                                            日別投稿数
                                        </h6>
                                        <div className="mb-3">
                                            <ButtonGroup size={window.innerWidth < 768 ? "sm" : ""}>
                                                <Button 
                                                    variant="outline-primary"
                                                    onClick={() => getPostsByDay().then(r => {
                                                        if (r.result) {
                                                            setPostsList(<Bar data={createGraphData(r.data, "日別投稿数 画像(すべて)")} />)
                                                        } else {
                                                            alert("取得失敗")
                                                        }
                                                    })}
                                                >
                                                    <Icon.Image className="me-1" />
                                                    画像(すべて)
                                                </Button>
                                                <Button 
                                                    variant="outline-primary"
                                                    onClick={() => getPostsOdaiByDay().then(r => {
                                                        if (r.result) {
                                                            setPostsList(<Bar data={createGraphData(r.data, "日別投稿数 画像(お題)")} />)
                                                        } else {
                                                            alert("取得失敗")
                                                        }
                                                    })}
                                                >
                                                    <Icon.Tag className="me-1" />
                                                    画像(お題)
                                                </Button>
                                                <Button 
                                                    variant="outline-primary"
                                                    onClick={() => getCommentPostsByDay().then(r => {
                                                        if (r.result) {
                                                            setPostsList(<Bar data={createGraphData(r.data, "日別投稿数 コメント(すべて)")} />)
                                                        } else {
                                                            alert("取得失敗")
                                                        }
                                                    })}
                                                >
                                                    <Icon.ChatDots className="me-1" />
                                                    コメント(すべて)
                                                </Button>
                                            </ButtonGroup>
                                        </div>
                                        <div style={{ height: "300px", overflow: "hidden" }}>
                                            {postsList}
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            {/* いいね数関連 */}
                            <Row className="g-3">
                                <Col lg={12}>
                                    <div style={{ 
                                        padding: "20px", 
                                        backgroundColor: "#ffffff", 
                                        borderRadius: "8px",
                                        border: "1px solid #dee2e6",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
                                    }}>
                                        <h6 style={{ 
                                            borderBottom: "2px solid #55AAFF", 
                                            fontSize: "18px", 
                                            fontWeight: "bold",
                                            paddingBottom: "8px",
                                            marginBottom: "16px"
                                        }}>
                                            日別いいね数
                                        </h6>
                                        <div className="mb-3">
                                            <Button 
                                                variant="primary"
                                                size={window.innerWidth < 768 ? "sm" : ""}
                                                onClick={() => getFavoriteCountByDay().then(r => {
                                                    if (r.result) {
                                                        setFavoriteList(<Bar data={createGraphData(r.data.list, "日別いいね数")} />)
                                                    } else {
                                                        alert("取得失敗")
                                                    }
                                                })}
                                            >
                                                <Icon.Heart className="me-1" />
                                                データ取得
                                            </Button>
                                        </div>
                                        <div style={{ height: "300px", overflow: "hidden" }}>
                                            {favoriteList}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Tab>
                    <Tab eventKey="report" title={"通報一覧"}>
                        <ButtonGroup className="mb-2" style={{ display: loginInfo.result === false ? "none" : "inline-block" }}>
                            {reportSearchDiv.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`report-search-div-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name={`report-search-div-radio`}
                                    value={radio.value}
                                    checked={radioReportSearchDiv === radio.value}
                                    onChange={(e) => {
                                        setReportSearchDiv(e.currentTarget.value)
                                        getReportList(reportSearchPage, e.currentTarget.value).then(r => {
                                            if (r.result) {
                                                setReportList(r.data)
                                            } else {
                                                dialog("エラー", r.errors)
                                            }
                                        })
                                    }}
                                >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                        <Row>
                            {reportList.map((d, i) => {
                                if (i === 10) return ""
                                return (
                                    <Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="m-1 p-3" key={i} style={{ width: "300px", border: "1px solid #000000", fontSize: "14px" }}>
                                        <Thumb type={d.type} data={{ group_id: d.id }} i={0} key={0} list={[]} />
                                        <table>
                                            <tr><th style={{ width: "90px" }}>ステータス</th><td>{d.status === 0 ? "未対応" : "対応済"}</td></tr>
                                            <tr><th>通報理由</th><td>{d.report_name}</td></tr>
                                            <tr><th>通報日時</th><td>{d.update_datetime}</td></tr>
                                            <tr><th>通報ユーザー名</th><td><Link target='_blank' to={"/user/" + d.user_id}>{d.user_name}</Link></td></tr>
                                        </table>
                                        <div className='mt-3'>
                                            <Button variant='outline-primary' onClick={() => dialog("詳細", d.text)}>報告詳細</Button>
                                            <Button variant='outline-primary' style={{ marginLeft: "10px" }}
                                                onClick={() => {
                                                    dialog("確認", <Container>
                                                        対応済みに更新しますか？<br />
                                                        <Button onClick={() => {
                                                            updateReportStatus(d.report_id, 1).then(r => {
                                                                if (r.result) {
                                                                    dialog("確認", "更新しました。")
                                                                } else {
                                                                    dialog("エラー", r.errors)
                                                                }
                                                            })
                                                        }}>更新する</Button>
                                                    </Container>)
                                                }}
                                            >対応済みに更新</Button>
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                        <Container className='d-flex justify-content-between mt-3' style={{ width: "200px" }}>
                            {reportSearchPage > 1 ? (
                                <Button onClick={() => {
                                    let page = reportSearchPage - 1
                                    setReportSearchPage(page)
                                }}>前</Button>
                            ) : <Button disabled>前</Button>}
                            {reportList.length > 10 ? (
                                <Button onClick={() => {
                                    let page = reportSearchPage + 1
                                    setReportSearchPage(page)
                                }}>次</Button>
                            ) : <Button disabled>次</Button>}
                        </Container>
                    </Tab>
                    <Tab eventKey="checkList" title={"対応後一覧(年齢制限)"}>
                        <ButtonGroup className="mb-2" style={{ display: loginInfo.result === false ? "none" : "inline-block" }}>
                            {checkListSearchDiv.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`user-check-list-search-div-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name={`user-check-list-search-div-radio`}
                                    value={radio.value}
                                    checked={radioUserCheckListSearchDiv === radio.value}
                                    onChange={(e) => {
                                        setUserCheckListSearchDiv(e.currentTarget.value)
                                        setUserCheckListSearchPage(1)
                                        getUserCheckList(1, e.currentTarget.value).then(r => {
                                            if (r.result) {
                                                setUserCheckList(r.data)
                                            } else {
                                                dialog("エラー", r.errors)
                                            }
                                        })
                                    }}
                                >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                        <Row>
                            {userCheckList.map((d, i) => {
                                if (i === 10) return ""
                                let currentNenrei = getAgeLimitStr(d.age_limit, d.sexual_expression)
                                let afterNenrei = getAgeLimitStr(parseInt(d.after_age_limit), parseInt(d.after_sexual_expression))
                                return (
                                    <Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="m-1 p-3" key={i} style={{ width: "300px", border: "1px solid #000000", fontSize: "14px" }}>
                                        <Thumb data={{ group_id: d.group_id }} i={i} key={0} list={[]} />
                                        <table>
                                            <tr><th style={{ width: "110px" }}>不整合</th><td>{d.mismatch === 1 ? <span style={{ color: "red", fontWeight: "bold" }}>あり</span> : "なし"}</td></tr>
                                            <tr><th>投稿者名</th><td><Link target='_blank' to={"/user/" + d.user_id}>{d.user_name}</Link></td></tr>
                                            <tr><th>タイトル</th><td>{d.title}</td></tr>
                                            <tr><th>現在の年齢制限</th><td>{currentNenrei}</td></tr>
                                            <tr><th>修正した年齢制限</th><td>{afterNenrei}</td></tr>
                                            <tr><th>修正日時</th><td>{d.admin_change_datetime}</td></tr>
                                        </table>
                                    </Col>
                                )
                            })}
                        </Row>
                        <Container className='d-flex justify-content-between mt-3' style={{ width: "200px" }}>
                            {userCheckListSearchPage > 1 ? (
                                <Button onClick={() => {
                                    let page = userCheckListSearchPage - 1
                                    setUserCheckListSearchPage(page)
                                }}>前</Button>
                            ) : <Button disabled>前</Button>}
                            {userCheckList.length > 10 ? (
                                <Button onClick={() => {
                                    let page = userCheckListSearchPage + 1
                                    setUserCheckListSearchPage(page)
                                }}>次</Button>
                            ) : <Button disabled>次</Button>}
                        </Container>
                    </Tab>
                    <Tab eventKey="topList" title={"対応件数が多い利用者"}>
                        <ButtonGroup className="mb-2" style={{ display: loginInfo.result === false ? "none" : "inline-block" }}>
                            {topListSearchDiv.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`top-list-search-div-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name={`top-list-search-div-radio`}
                                    value={radio.value}
                                    checked={radioTopListSearchDiv === radio.value}
                                    onChange={(e) => {
                                        setTopListSearchDiv(e.currentTarget.value)
                                        setTopListSearchPage(1)
                                        getTopList(1, e.currentTarget.value).then(r => {
                                            if (r.result) {
                                                setTopList(r.data)
                                            } else {
                                                dialog("エラー", r.errors)
                                            }
                                        })
                                    }}
                                >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                        <Row>
                            <Table striped bordered hover style={{ width: "100%" }}>
                                <thead>
                                    <tr><th>対象者</th><th>件数</th><th>最終</th></tr>
                                </thead>
                                <tbody>
                                    {topList.map((d, i) => {
                                        if (i === 10) return ""
                                        return (
                                            <>
                                                <tr><td><Link to={"/user/" + d.user_id} target='_blank'>{d.user_name}</Link></td><td>{d.count} {d.ai_generate_available !== undefined ? <>(過去7日間 <span style={{ color: d.before7day_count > 20 ? "red" : "inherit" }}>{d.before7day_count}</span>) {d.ai_generate_available === 0 ? <span style={{ color: "red" }}>利用停止</span> : ""}</> : ""}</td><td>{d.create_datetime}</td></tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Row>
                        <Container className='d-flex justify-content-between mt-3' style={{ width: "auto" }}>
                            {topListSearchPage > 1 ? (
                                <Button onClick={() => {
                                    let page = topListSearchPage - 1
                                    setTopListSearchPage(page)
                                }}>前</Button>
                            ) : <Button disabled>前</Button>}
                            {topList.length > 10 ? (
                                <Button onClick={() => {
                                    let page = topListSearchPage + 1
                                    setTopListSearchPage(page)
                                }}>次</Button>
                            ) : <Button disabled>次</Button>}
                        </Container>
                    </Tab>
                    <Tab eventKey="certifiedCreatorReviewList" title={"公認クリエイター申請者一覧"}>
                        <Container className='mb-3'>
                            <p style={{ borderBottom: "3px solid #55AAFF", fontSize: "24px", fontWeight: "bold" }}>検索して登録</p>
                            <FloatingLabel controlId="odai" label="ユーザー名" className='mt-3 mb-3 w-100'>
                                <Form.Control
                                    type="text"
                                    required
                                    onChange={(e) => {
                                        setTargetUserName(e.currentTarget.value)
                                        setLoading(true)
                                        userSearch(e.currentTarget.value).then(r => {
                                            if (r.result) {
                                                setUserList(r.data)
                                            }
                                            setLoading(false)
                                        })
                                    }}
                                />
                            </FloatingLabel>
                            <Button onClick={() => {
                                setLoading(true)
                                userSearch(targetUserName).then(r => {
                                    if (r.result) {
                                        setUserList(r.data)
                                    }
                                    setLoading(false)
                                })
                            }} disabled={loading}>{loading ? <Spinner animation="border" size="sm" /> : ""} 検索</Button>
                        </Container>
                        <Container>
                            <Table striped bordered hover style={{ width: "100%" }}>
                                <thead>
                                    <tr><th>ユーザー</th><th>公認クリエイター</th><th>認定</th></tr>
                                </thead>
                                <tbody>
                                    {userList.map(d => {
                                        return <tr><td><Link to={"/user/" + d.user_id} target='_blank'>{d.user_name}</Link></td><td>{d.certified_creator === 1 ? "はい" : "いいえ"}</td>
                                            <td><Button onClick={() => certifiedCreatorReviewResultHandlerAbsolute(d.user_id, 2)} disabled={d.certified_creator === 1}>認定</Button></td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                        </Container>
                        <Container>
                            <p style={{ borderBottom: "3px solid #55AAFF", fontSize: "24px", fontWeight: "bold" }}>申請一覧</p>
                            <Table striped bordered hover style={{ width: "100%" }}>
                                <thead>
                                    <tr><th>対象者</th><th>申請日時</th><th>ユーザー登録日</th><th>審査結果</th></tr>
                                </thead>
                                <tbody>
                                    {certifiedCreatorReviewList.map((d, i) => {
                                        if (i === 10) return ""
                                        return (
                                            <>
                                                <tr><td><Link to={"/user/" + d.user_id} target='_blank'>{d.user_name}</Link></td><td>{d.creator_review_datetime}</td><td>{d.create_datetime}</td>
                                                    <td>
                                                        <Button className='m-1'
                                                            onClick={() => certifiedCreatorReviewResultHandler(d.user_id, 2)}
                                                        >認定</Button><Button className='m-1'
                                                            onClick={() => certifiedCreatorReviewResultHandler(d.user_id, 3)}
                                                        >非認定</Button>
                                                    </td></tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Container>
                        <Container className='d-flex justify-content-between mt-3' style={{ width: "auto" }}>
                            {certifiedCreatorReviewListSearchPage > 1 ? (
                                <Button onClick={() => {
                                    let page = certifiedCreatorReviewListSearchPage - 1
                                    setTopListSearchPage(page)
                                }}>前</Button>
                            ) : <Button disabled>前</Button>}
                            {certifiedCreatorReviewList.length > 10 ? (
                                <Button onClick={() => {
                                    let page = certifiedCreatorReviewListSearchPage + 1
                                    setTopListSearchPage(page)
                                }}>次</Button>
                            ) : <Button disabled>次</Button>}
                        </Container>
                    </Tab>
                    <Tab eventKey="statusList" title={"公認クリエイターのステータス"}>
                        <Container>
                            過去1か月以内の投稿数
                            <Table striped bordered hover style={{ width: "100%" }}>
                                <thead>
                                    <tr><th>ユーザー名</th><th>投稿タイプ</th><th>投稿数</th></tr>
                                </thead>
                                <tbody>
                                    {statusList.map((d, i) => {
                                        //if(i === 10) return ""
                                        return (
                                            <>
                                                <tr><td><Link to={"/user/" + d.user_id} target='_blank'>{d.user_name}</Link></td><td>{d.type}</td><td>{d.count}</td></tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Container>
                    </Tab>
                    <Tab eventKey="problemList" title={"再公開申請一覧"}>
                        <Container>
                            ・1.隠蔽処理が不足している<br />
                            ・2.児童ポルノの可能性のある投稿<br />
                            ・3.全年齢にはできない可能性のある投稿<br />
                            投稿の強制非公開後、審査依頼が来た場合にここに表示されます。<br />
                            3の場合は適切な年齢制限に修正してから再公開する<br />
                            3の場合で、サーチバンになったユーザーは審査が終わらないと新規投稿不可になります。
                            <Table striped bordered hover style={{ width: "100%" }}>
                                <thead>
                                    <tr><th>タイトル</th><th>更新日時</th><th>理由</th><th>審査結果</th></tr>
                                </thead>
                                <tbody>
                                    {problemList.map((d, i) => {
                                        //if(i === 10) return ""
                                        let text = ""
                                        const reason = ["隠蔽処理不足", "児童ポルノ", "全年齢ではない可能性[自動判定]"]
                                        return (
                                            <>
                                                <tr><td style={{ cursor: "pointer" }} onClick={() => {
                                                    setShowImageViewPopup(true)
                                                    setGroupId(d.group_id)
                                                }}>{d.title}</td><td>{d.update_datetime}</td>
                                                    <td>{reason[d.problem_reason - 1]}</td>
                                                    <td>
                                                        <Button className='m-1'
                                                            onClick={() => problemResultHandler(d.group_id, 1)}
                                                        >再公開</Button><Button className='m-1'
                                                            onClick={() => problemResultHandler(d.group_id, 2)}
                                                        >差し戻し</Button>
                                                    </td></tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Container>
                    </Tab>
                    <Tab eventKey="chargeList" title={"コインチャージ用の銀行振込"}>
                        <Container>
                            <Table striped bordered hover style={{ width: "100%" }}>
                                <thead>
                                    <tr><th>ユーザー名</th><th>振込予定日</th><th>振込予定金額</th><th>付与コイン</th><th>振込日</th><th>振込予定名義</th><th>状態</th></tr>
                                </thead>
                                <tbody>
                                    {chargeList.map((d, i) => {
                                        //if(i === 10) return ""
                                        return (
                                            <>
                                                <tr><td><Link to={"/user/" + d.user_id} target='_blank'>{d.user_name}</Link></td><td>{d.booking_date}</td><td>{d.amount.toLocaleString()} 円</td><td>{d.coin.toLocaleString()} コイン</td>
                                                    <td>{d.confirm_date === "0000-00-00" || d.confirm_date === "9999-12-31" ? "" : d.confirm_date}</td>
                                                    <td>{d.name === "" ? "" : <>{d.name}({d.name_half})</>}</td>
                                                    <td>{d.status === 1 ? "振込確認中" : "振込確認済"}
                                                        &nbsp;<Button onClick={() => {
                                                            setChargeId(d.charge_id)
                                                            setShowChargeConfirm(true)
                                                        }} disabled={d.status !== 1}>振込確認</Button>
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Container>
                    </Tab>
                    <Tab eventKey="idList" title={"身分証確認申請一覧"}>
                        <Container fluid className="px-2">
                            <Row className="mb-3">
                                <Col>
                                    <div style={{ 
                                        padding: window.innerWidth < 768 ? "8px" : "12px", 
                                        backgroundColor: "#f8f9fa", 
                                        borderRadius: "8px",
                                        border: "1px solid #dee2e6"
                                    }}>
                                        <h5 className="mb-2" style={{ 
                                            color: "#495057",
                                            fontSize: window.innerWidth < 768 ? "16px" : "20px"
                                        }}>
                                            <Icon.InfoCircle className="me-2" />
                                            身分証確認申請一覧
                                        </h5>
                                        <p className="mb-0 text-muted" style={{
                                            fontSize: window.innerWidth < 768 ? "13px" : "14px"
                                        }}>
                                            ユーザーから提出された身分証明書の確認を行います。各申請をクリックして詳細を確認し、承認または差し戻しを行ってください。
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            
                            {idList.length === 0 ? (
                                <Row>
                                    <Col className="text-center py-5">
                                        <Icon.FileEarmarkText size={window.innerWidth < 768 ? 32 : 48} className="text-muted mb-3" />
                                        <h5 className="text-muted" style={{ fontSize: window.innerWidth < 768 ? "16px" : "20px" }}>申請はありません</h5>
                                        <p className="text-muted" style={{ fontSize: window.innerWidth < 768 ? "13px" : "14px" }}>現在、身分証確認の申請はありません。</p>
                                    </Col>
                                </Row>
                            ) : (
                                <Row className="g-2">
                                    {idList.map((d, i) => {
                                        const statusColor = d.status === 2 ? "warning" : "success";
                                        const statusText = d.status === 2 ? "確認待ち" : "確認済";
                                        const isInvalid = d.user_status !== 0;
                                        const isMobile = window.innerWidth < 768;
                                        
                                        return (
                                            <Col xs={12} md={6} lg={4} className="mb-3" key={i}>
                                                <div style={{
                                                    border: `2px solid ${d.status === 2 ? "#ffc107" : "#28a745"}`,
                                                    borderRadius: isMobile ? "8px" : "12px",
                                                    backgroundColor: "#ffffff",
                                                    boxShadow: isMobile ? "0 1px 4px rgba(0,0,0,0.1)" : "0 2px 8px rgba(0,0,0,0.1)",
                                                    transition: "all 0.2s ease",
                                                    height: "100%"
                                                }}
                                                className="h-100"
                                                onMouseEnter={(e) => {
                                                    if (!isMobile) {
                                                        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.15)";
                                                        e.currentTarget.style.transform = "translateY(-2px)";
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!isMobile) {
                                                        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                                                        e.currentTarget.style.transform = "translateY(0)";
                                                    }
                                                }}>
                                                    
                                                    {/* ヘッダー部分 */}
                                                    <div style={{
                                                        backgroundColor: d.status === 2 ? "#fff3cd" : "#d4edda",
                                                        padding: isMobile ? "12px" : "16px",
                                                        borderRadius: isMobile ? "6px 6px 0 0" : "10px 10px 0 0",
                                                        borderBottom: "1px solid #dee2e6"
                                                    }}>
                                                        <div className={isMobile ? "d-flex flex-column" : "d-flex justify-content-between align-items-center"}>
                                                            <div className={isMobile ? "mb-2" : ""}>
                                                                <h6 className="mb-1" style={{ 
                                                                    fontWeight: "600",
                                                                    fontSize: isMobile ? "14px" : "16px"
                                                                }}>
                                                                    <Link 
                                                                        to={"/user/" + d.user_id} 
                                                                        target='_blank'
                                                                        style={{ 
                                                                            textDecoration: "none",
                                                                            color: "#007bff",
                                                                            fontWeight: "600"
                                                                        }}
                                                                    >
                                                                        <Icon.Person className="me-1" size={isMobile ? 14 : 16} />
                                                                        {d.user_name}
                                                                    </Link>
                                                                </h6>
                                                                <small className="text-muted" style={{ fontSize: isMobile ? "11px" : "12px" }}>
                                                                    <Icon.Clock className="me-1" size={isMobile ? 11 : 12} />
                                                                    {isMobile ? d.update_datetime.substring(0, 16) : d.update_datetime}
                                                                </small>
                                                            </div>
                                                            <div className={isMobile ? "align-self-end" : "text-end"}>
                                                                <span className={`badge bg-${statusColor} mb-1`} style={{
                                                                    fontSize: isMobile ? "10px" : "12px"
                                                                }}>
                                                                    {statusText}
                                                                </span>
                                                                {isInvalid && (
                                                                    <div>
                                                                        <span className="badge bg-danger" style={{
                                                                            fontSize: isMobile ? "10px" : "12px"
                                                                        }}>無効</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* コンテンツ部分 */}
                                                    <div style={{ padding: isMobile ? "12px" : "16px" }}>
                                                        {/* ユーザー情報セクション */}
                                                        <div className="mb-3">
                                                            <h6 style={{ 
                                                                color: "#495057", 
                                                                borderBottom: "2px solid #007bff",
                                                                paddingBottom: "3px",
                                                                marginBottom: isMobile ? "8px" : "12px",
                                                                fontSize: isMobile ? "12px" : "14px",
                                                                fontWeight: "600"
                                                            }}>
                                                                <Icon.PersonBadge className="me-1" size={isMobile ? 12 : 14} />
                                                                登録済みユーザー情報
                                                            </h6>
                                                            <Row className="g-2">
                                                                <Col xs={6}>
                                                                    <small className="text-muted d-block" style={{ 
                                                                        fontSize: isMobile ? "10px" : "11px" 
                                                                    }}>性別</small>
                                                                    <span style={{ fontSize: isMobile ? "11px" : "13px" }}>
                                                                        {d.user_sex === 0 ? "未設定" : d.user_sex === 1 ? "男性" : "女性"}
                                                                    </span>
                                                                </Col>
                                                                <Col xs={6}>
                                                                    <small className="text-muted d-block" style={{ 
                                                                        fontSize: isMobile ? "10px" : "11px" 
                                                                    }}>誕生日</small>
                                                                    <span style={{ fontSize: isMobile ? "11px" : "13px" }}>
                                                                        {d.birthday === "0000-00-00" ? "未設定" : 
                                                                         isMobile ? d.birthday.replace(/-/g, "/").substring(2) : d.birthday.replace(/-/g, "/")}
                                                                    </span>
                                                                </Col>
                                                            </Row>
                                                        </div>

                                                        {/* 申請情報セクション */}
                                                        <div className="mb-3">
                                                            <h6 style={{ 
                                                                color: "#495057", 
                                                                borderBottom: "2px solid #28a745",
                                                                paddingBottom: "3px",
                                                                marginBottom: isMobile ? "8px" : "12px",
                                                                fontSize: isMobile ? "12px" : "14px",
                                                                fontWeight: "600"
                                                            }}>
                                                                <Icon.CardText className="me-1" size={isMobile ? 12 : 14} />
                                                                身分証明書申請情報
                                                            </h6>
                                                            
                                                            {/* 氏名情報 */}
                                                            <div className="mb-2">
                                                                <small className="text-muted d-block" style={{ 
                                                                    fontSize: isMobile ? "10px" : "11px" 
                                                                }}>氏名</small>
                                                                <div style={{ fontSize: isMobile ? "11px" : "13px" }}>
                                                                    <strong>{d.name_sei} {d.name_mei}</strong>
                                                                    <div className="text-muted" style={{ fontSize: isMobile ? "10px" : "12px" }}>
                                                                        フリガナ: {d.name_sei_kana} {d.name_mei_kana}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* 基本情報 */}
                                                            <Row className="g-2 mb-2">
                                                                <Col xs={6}>
                                                                    <small className="text-muted d-block" style={{ 
                                                                        fontSize: isMobile ? "10px" : "11px" 
                                                                    }}>性別</small>
                                                                    <span style={{ fontSize: isMobile ? "11px" : "13px" }}>
                                                                        {d.sex === "1" ? "男性" : "女性"}
                                                                    </span>
                                                                </Col>
                                                                <Col xs={6}>
                                                                    <small className="text-muted d-block" style={{ 
                                                                        fontSize: isMobile ? "10px" : "11px" 
                                                                    }}>生年月日</small>
                                                                    <span style={{ fontSize: isMobile ? "11px" : "13px" }}>
                                                                        {isMobile ? `${d.year.substring(2)}/${d.month}/${d.day}` : `${d.year}/${d.month}/${d.day}`}
                                                                    </span>
                                                                </Col>
                                                            </Row>

                                                            {/* 住所情報 */}
                                                            <div className="mb-2">
                                                                <small className="text-muted d-block" style={{ 
                                                                    fontSize: isMobile ? "10px" : "11px" 
                                                                }}>住所</small>
                                                                <div style={{ 
                                                                    fontSize: isMobile ? "10px" : "13px", 
                                                                    lineHeight: "1.3" 
                                                                }}>
                                                                    <div>〒{d.post_code}</div>
                                                                    <div>{d.country}</div>
                                                                    <div>{d.prefectures}</div>
                                                                    <div style={{ 
                                                                        wordBreak: "break-all",
                                                                        lineHeight: "1.2"
                                                                    }}>{d.address1}</div>
                                                                    {d.address2 && <div style={{ 
                                                                        wordBreak: "break-all",
                                                                        lineHeight: "1.2"
                                                                    }}>{d.address2}</div>}
                                                                    {d.address3 && <div style={{ 
                                                                        wordBreak: "break-all",
                                                                        lineHeight: "1.2"
                                                                    }}>{d.address3}</div>}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* アクションボタン */}
                                                        <div className="d-grid">
                                                            <Button 
                                                                variant={d.status === 2 ? "warning" : "outline-secondary"}
                                                                size={isMobile ? "sm" : "sm"}
                                                                onClick={() => {
                                                                    setTargetUserId(d.user_id)
                                                                    setCurrentIdInfo(d)
                                                                    setShowIdConfirm(true)
                                                                }} 
                                                                disabled={d.status !== 2}
                                                                style={{
                                                                    fontWeight: "600",
                                                                    padding: isMobile ? "6px 12px" : "8px 16px",
                                                                    fontSize: isMobile ? "12px" : "14px"
                                                                }}
                                                            >
                                                                {d.status === 2 ? (
                                                                    <>
                                                                        <Icon.Search className="me-1" size={isMobile ? 12 : 14} />
                                                                        {isMobile ? "身分証確認" : "身分証を確認する"}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Icon.CheckCircle className="me-1" size={isMobile ? 12 : 14} />
                                                                        確認済み
                                                                    </>
                                                                )}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            )}
                        </Container>
                    </Tab>
                    <Tab eventKey="rewardsList" title={"特典の抽選"}>
                        <Container>
                            <Button className='mb-3' onClick={() => {
                                judgeRewardsApplicants().then(r => {
                                    if (r.result) {
                                        setRewardsApplicants(r.data)
                                        alert("実施完了")
                                    } else {
                                        dialog("", r.errors)
                                    }
                                })
                            }}>抽選実施</Button>
                            <Table striped bordered hover>
                                <thead>
                                    <tr><th>ユーザー名</th><th>基準月</th><th>応募日</th><th>口数</th><th>商品名</th><th>当落</th><th>配送状況</th><th>配送日</th></tr>
                                </thead>
                                <tbody>
                                    {rewardsApplicants && rewardsApplicants.map((d, i) => {
                                        let deliveryStatusStr = d.delivery_status
                                        return <tr key={i}><td>{d.user_name}</td><td>{d.base_ym.substr(0, 7)}</td><td>{d.ymd}</td><td>{d.entry_count}</td><td>{d.item_name}</td><td>{getLabel(d.status)}</td><td>{d.status === "WON" ? (<span style={{ fontWeight: "bold" }}>{d.delivery_status === 0 ? "未配送" : (d.delivery_status === 2 ? "キャンセル" : "配送済")}</span>) : "-"} {d.status === "WON" && d.delivery_status === 0 ? <>
                                            <Button onClick={() => {
                                                setShowDeliveryInfo(true)
                                                setRewardsStatusId(d.rewards_status_id)
                                            }}>配送済に変更</Button>
                                            <CommonDialog open={showDeliveryInfo} onClose={() => setShowDeliveryInfo(false)} content={<>
                                                <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                    <InputLabel id={"delivery-company-code" + i}>配送業者</InputLabel>
                                                    <Select
                                                        labelId="delivery-company-label"
                                                        id={"delivery-company-code" + i}
                                                        label="Delivery company"
                                                        onChange={(e) => {
                                                            setDeliveryCompany(e.target.value)
                                                        }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        {[{ "code": "yamato", "label": "ヤマト運輸" }, { "code": "japanpost", "label": "日本郵便" }].map(d => {
                                                            return <MenuItem value={d.code}>{d.label}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                <TextField
                                                    label="追跡番号"
                                                    id={"tracking-number" + i}
                                                    sx={{ m: 1 }}
                                                    onChange={(e) => {
                                                        setTrackingNumber(e.target.value)
                                                    }}
                                                />
                                                <br />
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DemoContainer components={['DatePicker']}>
                                                        <DatePicker
                                                            className='m-1'
                                                            label="配送日"
                                                            format="YYYY/MM/DD"
                                                            slotProps={{
                                                                textField: {
                                                                    inputProps: {
                                                                        placeholder: 'YYYY/MM/DD'
                                                                    }
                                                                }
                                                            }}
                                                            onChange={(e) => setDeliveryDate(e.format("YYYY-MM-DD"))}
                                                        />
                                                    </DemoContainer>
                                                </LocalizationProvider>
                                                <TextField
                                                    label="配送金額"
                                                    id={"delivery_amount" + i}
                                                    sx={{ m: 1 }}
                                                    onChange={(e) => {
                                                        setDeliveryAmount(e.target.value)
                                                    }}
                                                />
                                                <div className='m-1'>領収書等：<input type='file' id="receipt" multiple ref={receipt} /></div>
                                                {deliveryErrorMessage.length > 0 ? <Alert severity='warning'>{deliveryErrorMessage}</Alert> : ""}
                                                <LoadingButton variant='contained' loading={loading} className='m-1' onClick={() => {
                                                    setLoading(true)
                                                    setDeliveryErrorMessage("")
                                                    updateDeliveryStatus(rewardsStatusId, "1", deliveryCompany, trackingNumber, deliveryDate, deliveryAmount, receipt).then(r => {
                                                        if (r.result) {
                                                            getRewardsApplicants().then(r => {
                                                                if (r.result) {
                                                                    setShowDeliveryInfo(false)
                                                                    setRewardsApplicants(r.data)
                                                                }
                                                            })
                                                        } else {
                                                            setDeliveryErrorMessage(r.errors)
                                                        }
                                                        setLoading(false)
                                                    })
                                                }}>確定</LoadingButton>
                                            </>} />
                                            &nbsp;
                                            <Button variant='warning' onClick={() => {
                                                updateDeliveryStatus(d.rewards_status_id, "2").then(r => {
                                                    if (r.result) {
                                                        getRewardsApplicants().then(r => {
                                                            if (r.result) {
                                                                setRewardsApplicants(r.data)
                                                            }
                                                        })
                                                    } else {
                                                        dialog("", r.errors)
                                                    }
                                                })
                                            }}>配送をキャンセル</Button>
                                        </> : ""}<br />{d.status === "WON" && d.delivery_status === 0 ? <>配送先：〒{d.post_code} {d.prefectures} {d.address1} {d.address2} {d.address3}<br />宛名：<ruby> {d.name_sei} {d.name_mei} <rp>(</rp><rt>{d.name_sei_kana} {d.name_mei_kana}</rt><rp>)</rp> </ruby><br />電話番号：{d.phone_number}</> : ""}
                                            {d.delivery_status === 1 ? (<>
                                                配送業者：{d.delivery_company}&nbsp;
                                                追跡番号：{d.tracking_number}<br />
                                                配送金額：{d.delivery_amount}<br />
                                                <LoadingButton loading={loading} variant='outlined' onClick={() => {
                                                    setLoading(true)
                                                    getFileList(d.rewards_status_id).then(r => {
                                                        if (r.result) {
                                                            setPreviewImageList(r.data.filter(d => d.ext === "jpg" || d.ext === "jpeg" || d.ext === "gif" || d.ext === "png" || d.ext === "webp").map(d => d.file))
                                                            setShowPreviewImage(true)
                                                        } else {
                                                            alert(r.errors)
                                                        }
                                                        setLoading(false)
                                                    })
                                                }}>画像を表示</LoadingButton>
                                                {d.files.map(d => {
                                                    if (d.ext === "jpg" || d.ext === "jpeg" || d.ext === "gif" || d.ext === "png" || d.ext === "webp") {
                                                        /*return <Icon.Image className='m-1' style={{cursor:"pointer"}} onClick={() => {
                                                            getFile(d.file_id).then(r => {
                                                                if(r.result){
                                                                    setPreviewImageList([r.data.file])
                                                                    setShowPreviewImage(true)
                                                                } else {
                                                                    alert(r.errors)
                                                                }
                                                            })
                                                        }} />*/
                                                    } else {
                                                        return <Icon.FileArrowDown onClick={() => {
                                                            getFile(d.file_id).then(r => {
                                                                if (r.result) {
                                                                    downloadBase64File(
                                                                        r.data.file,
                                                                        r.data.file_id + "." + r.data.ext,
                                                                    );
                                                                } else {
                                                                    alert(r.errors)
                                                                }
                                                            })
                                                        }} className='m-1' style={{ cursor: "pointer" }} />
                                                    }
                                                })}
                                                <CommonDialog fullScreen={true} open={showPreviewImage} content={<Container>
                                                    <Button onClick={() => setShowPreviewImage(false)}>閉じる</Button>
                                                    {previewImageList.map(img => {
                                                        return <img src={img} width={"100%"} />
                                                    })}
                                                    <Button onClick={() => setShowPreviewImage(false)}>閉じる</Button>
                                                </Container>} onClose={() => setShowPreviewImage(false)} />
                                            </>) : ""}
                                        </td><td>{d.delivery_date}</td></tr>
                                    })}
                                </tbody>
                            </Table>
                        </Container>
                    </Tab>
                    <Tab eventKey="bulkMessage" title={"一括メッセージ"}>
                        <Container>
                            <FloatingLabel controlId="bulk-message" label="メッセージ" className='mt-3 mb-3 w-100'>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    required
                                    onChange={(e) => setBulkMessage(e.currentTarget.value)}
                                />
                            </FloatingLabel>
                            <FloatingLabel controlId="bulk-message-url" label="URL" className='mt-3 mb-3 w-100'>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => setBulkMessageUrl(e.currentTarget.value)}
                                />
                            </FloatingLabel>
                            <InputGroup className="mb-3">
                                <InputGroup.Checkbox
                                    id="bulk-message-fixed"
                                    onChange={(e) => setBulkMessageFixed(e.currentTarget.checked)}
                                />
                                <Form.Control type="text" defaultValue="固定表示" readOnly />
                            </InputGroup>
                            <FloatingLabel controlId="bulk-message-reason" label="理由" className='mt-3 mb-3 w-100'>
                                <Form.Select
                                    required
                                    onChange={(e) => setBulkMessageReason(e.currentTarget.value)}
                                >
                                    <option value="">選択してください</option>
                                    <option value="1">機能追加</option>
                                    <option value="2">機能改善</option>
                                    <option value="3">イベント</option>
                                    <option value="4">提携</option>
                                    <option value="5">その他</option>
                                </Form.Select>
                            </FloatingLabel>
                            <FloatingLabel controlId="bulk-message-release-datetime" label="公開日時" className='mt-3 mb-3 w-100'>
                                <Form.Control
                                    type="datetime-local"
                                    required
                                    onChange={(e) => setBulkMessageReleaseDatetime(e.currentTarget.value)}
                                />
                            </FloatingLabel>
                            <Button onClick={() => {
                                if (bulkMessage === "" || bulkMessageReason === "" || bulkMessageReleaseDatetime === "") {
                                    alert("メッセージ、理由、公開日時は必須です。")
                                    return
                                }
                                setLoading(true)
                                sendBulkMessage(bulkMessage, bulkMessageUrl, bulkMessageFixed, bulkMessageReason, bulkMessageReleaseDatetime).then(r => {
                                    if (r.result) {
                                        alert("メッセージ送信完了")
                                    } else {
                                        alert(r.errors)
                                    }
                                    setLoading(false)
                                })
                            }} disabled={loading}>{loading ? <Spinner animation="border" size="sm" /> : ""} 送信</Button>
                        </Container>
                    </Tab>
                </Tabs>
            </Container>
            <CommonDialog open={showChargeConfirm} content={
                <Container>
                    <FormLabel>振込日</FormLabel>
                    <Form.Control
                        type="date"
                        required
                        value={chargeConfirmDate}
                        onChange={(e) => setChargeConfirmDate(e.currentTarget.value)}
                    />
                    <TextField size='small' id="remarks" label="備考" variant="outlined" className='m-2' multiline
                        onChange={(e) => {
                            setChargeRemarks(e.target.value)
                        }} /><br />
                    <LoadingButton onClick={() => {
                        if (chargeConfirmDate === "") {
                            alert("振込確認日を入力してください。")
                            return
                        }
                        setLoading(true)
                        chargeConfirm(chargeId, chargeConfirmDate, chargeRemarks).then(r => {
                            if (r.result) {
                                getChargeList(chargePage).then(r => {
                                    if (r.result) {
                                        setChargeList(r.data)
                                    } else {
                                        alert("エラー")
                                    }
                                })
                            } else {
                                alert(r.errors)
                            }
                            setChargeId("")
                            setChargeConfirmDate("")
                            setChargeRemarks("")
                            setShowChargeConfirm(false)
                            setLoading(false)
                        })
                    }} loading={loading} variant='contained'>登録</LoadingButton>
                </Container>
            } onClose={() => {
                setShowChargeConfirm(false)
                setChargeConfirmDate("")
            }} />
            <CommonDialog open={showIdConfirm} content={
                <Container>
                    <FormLabel>身分証確認</FormLabel>
                    1枚目
                    <Image src={idImage.img1} style={{ width: "100%" }} />
                    2枚目
                    <Image src={idImage.img2} style={{ width: "100%" }} />
                    3枚目
                    <Image src={idImage.img3} style={{ width: "100%" }} />
                    IDセルフィー
                    <Image src={idImage.selfie} style={{ width: "100%" }} />
                    {[
                        { "div": "", "label": "確認完了" },
                        { "div": "MISMATCH", "label": "提出内容不備・不一致" },
                        { "div": "UNCLEAR", "label": "内容不明瞭" },
                        { "div": "PRIVATE", "label": "社内基準(理由未公開)" },
                    ].map((d, i) => <>
                        <Button variant={i > 0 ? "warning" : "primary"} className='m-2' onClick={() => {
                            setLoading(true)
                            idResultRegist(targetUserId, d.div).then(r => {
                                if (r.result) {
                                    getIdList(idPage).then(r => {
                                        if (r.result) {
                                            setIdList(r.data)
                                        } else {
                                            alert("エラー")
                                        }
                                    })
                                } else {
                                    alert(r.errors)
                                }
                                setShowIdConfirm(false)
                                setLoading(false)
                            })
                        }} disabled={loading}>{d.label}</Button>
                        {i === 0 ? <br /> : ""}
                    </>)}
                </Container>
            } onClose={() => {
                setShowIdConfirm(false)
            }} />
            <Container>

            </Container>
            <Footer />
        </div>
    )
}

export default Admin;
